import { InterviewSidebarSection } from "../Components/InterviewSidebarSection";
import {
    formatPhone,
    formatSsn,
    getFormattedAddress,
    getFormattedNameFromObject,
} from "../../../../services/stringService";
import { RowWithSingleField, YesNoRow } from "../Components/SidebarComponents";
import React from "react";
import { getMonthDiff } from "../../../../services/dateFormatter";
import { InterviewSidebarPregnancyItem } from "../Components/InterviewSidebarPregnancyItem";

function getGender(gender) {
    switch (gender) {
        case "Male":
            return "M";
        case "Female":
            return "F";
        default:
            return "U";
    }
}

const GenericEntry = ({ data }) => (
    <div className="mini-section">
        <div className="row">
            <h4>
                {getFormattedNameFromObject(data)}
                {data.relationshipToPatient != null && <> ({data.relationshipToPatient})</>}
            </h4>
        </div>

        <div className="row">
            {data.maritalStatus}, {data.gender}, {data.age} {data.age > 1 ? "years" : "year"} old.
        </div>
        <InterviewSidebarPregnancyItem pregnancy={data.pregnancy} />
        {data?.ssn != null && (
            <RowWithSingleField title="SSN" value={formatSsn(data?.ssn)} valueClassName="no-upscope" />
        )}
        {data?.mrn != null && <RowWithSingleField title="MRN" value={data?.mrn} />}
        {data?.preferredLanguage && <RowWithSingleField title="Preferred Language" value={data?.preferredLanguage} />}
        <YesNoRow title={"US Citizen"} isYes={data?.isUsCitizen} />
        {!data?.isUsCitizen && <RowWithSingleField title="Immigration Status" value={data?.immigrationStatus} />}
        <RowWithSingleField title="Address" value={getFormattedAddress(data?.address)} />
        {data?.isMailingAddressDifferent === false && (
            <YesNoRow title={"Is Mailing Address Same"} isYes={!data?.isMailingAddressDifferent} />
        )}
        {data?.isMailingAddressDifferent === true && (
            <RowWithSingleField
                className="mailing-address"
                title="Mailing Address"
                value={getFormattedAddress(data?.mailingAddress)}
            />
        )}
        <RowWithSingleField
            title={"Phone Number"}
            value={
                <>
                    {formatPhone(data?.primaryPhoneNumber?.phoneNumber)}{" "}
                    {data?.primaryPhoneNumber?.phoneType != null && `(${data?.primaryPhoneNumber?.phoneType})`}
                </>
            }
        />
         { data?.documentInfo?.documentType != null && (
             <>
                 <RowWithSingleField
                     title={"Id Type"}
                     value={
                         <>
                             {data?.documentInfo?.documentType}{" "}
                         </>
                     }
                 /><RowWithSingleField
                     title={"Id Number"}
                     value={
                         <>
                             {data?.documentInfo?.documentNumber}{" "}
                         </>
                     }
                 />
                 {data?.documentInfo?.documentType === "Driver's License" && (
                 <RowWithSingleField
                     title={"Issueing State"}
                     value={
                         <>
                             {data?.documentInfo?.issuingState}{" "}
                         </>
                     }
                 />
                 )}
             </>
         )}
    </div>
);

export const InterviewSidebarEntry = ({ entry, ...props }) => {
    return (
        <InterviewSidebarSection title="Patient Information" {...props}>
            <GenericEntry data={entry?.patient} />
            {entry.isResponsiblePartyDifferentFromPatient && <GenericEntry data={entry?.responsibleParty} />}
        </InterviewSidebarSection>
    );
};
